module.exports = "<nv-react-component component=\"LearnerProgressDashboard\"></nv-react-component>";